import { render, staticRenderFns } from "./MontagemCargaPartesEnvForm.vue?vue&type=template&id=0bc4e330"
import script from "./MontagemCargaPartesEnvForm.vue?vue&type=script&lang=js"
export * from "./MontagemCargaPartesEnvForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports